<template>
  <div class="sy-date">
    <read-text v-if='isPureText' :value='pureText'></read-text>
    <el-date-picker v-else v-on="$listeners" v-bind="{...$attrs, ...$props }" :placeholder="placeholder" :picker-options="pickerOptions" :size="size">
    </el-date-picker>
  </div>
</template>
<style lang="scss">
.sy-date {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
<script>
import { dateProps, initValue } from './index.js'

export default {
  name: 'date',
  props: dateProps,
  computed: {
    pureText () {
      return this.isPureText ? initValue(this.value) : this.value
    }
  },
  data () {
    return {
      // 当前时间日期选择器特有的选项 Object
      pickerOptions: {
        // 设置禁用状态，参数为当前日期，要求返回 Boolean
        disabledDate: (currentTime) => {
          // 是否能早于添加数据时的日期
          if (this.canBeforeAddData === false) {
            const newDate = new Date().getTime() - 24 * 60 * 60 * 1000
            return currentTime.getTime() < newDate
          }
          return false
        }
      }
    }
  }
}
</script>
